import DataFetch from '../../Utility/data-fetch'
import Storage from '../../Utility/site-cookies'

const call = (baseUrl, passageUrl, query, uniqueId, otherId) => {
    return {
        storage: window.localStorage,

        id: uniqueId,
        otherId: otherId,
        query: query,
        open: false,
        translationBooks: [],
        currentTranslation: {},
        currentTranslationCode: '',
        currentOtherTranslation: {},
        currentOtherTranslationCode: '',
        translations: [],
        recentTranslations: [],
        loading: false,
        showRecent: false,

        async start() {
            this.id = "-" + uniqueId;
            this.otherId = "-" + otherId;
            this.currentTranslation = {code: 'niv', title: 'New International Version'}

            const version = Storage().readPref(`translation${this.id}`, 'niv')
            const otherVersion = Storage().readPref(`translation${this.otherId}`, 'niv')
            await this.getAllTranslation({code: version, otherCode: otherVersion})

            console.log(otherVersion)
        },

        selectTranslation(translation) {
            Storage().writePref(`translation${this.id}`, translation.code);

            this.currentTranslationCode = translation.code;
            this.pushRecent(translation);
            this.gotoPassageForTranslation(this.query)
        },

        pushRecent(translation) {
            if (this.recentTranslations.some(rt => rt.code === translation.code)) {
                const newTopIndex = this.recentTranslations.findIndex(rt => rt.code === translation.code);

                // Swap
                let oldTop = this.recentTranslations[0];
                this.recentTranslations[0] = this.recentTranslations[newTopIndex];
                this.recentTranslations[newTopIndex] = oldTop;
            } else {
                this.recentTranslations.unshift(translation);

                if (this.recentTranslations.length > 5) {
                    this.recentTranslations.pop();
                }
            }

            this.storage.setItem("recent-translations", JSON.stringify(this.recentTranslations));

            this.currentTranslation = translation
        },

        gotoPassageForTranslation(query) {
            if (!query || query.length === 0) {
                return;
            }

            window.location.href = `${passageUrl}?q=${query.replace(" ", "+").toLowerCase()}&${this.id.replace("-", "")}=${this.currentTranslationCode}&${this.otherId.replace("-", "")}=${this.currentOtherTranslationCode}`
        },

        async getAllTranslation(translation) {
            // Already in memory? Return.
            if (this.translations && this.translations.length > 0) {
                return;
            }

            this.loading = true;

            await DataFetch.get(baseUrl, {
                params: {
                    translationCode: !translation || !translation.code ? "niv" : translation.code
                },
            })
                .then(response => {
                    this.currentTranslationCode = translation.code;
                    this.currentOtherTranslationCode = translation.otherCode || this.currentOtherTranslationCode || 'niv'
                    this.translations = response.data.translations;
                    this.currentTranslation = this.translations.find(s => s.code === this.currentTranslationCode)
                    this.currentOtherTranslation = this.translations.find(s => s.code === this.currentOtherTranslationCode)

                    // Load Recent.
                    try {
                        this.recentTranslations = JSON.parse(this.storage.getItem("recent-translations")) || [];
                    } catch (err) {
                        console.log("BST:TRSELECT - Invalid JSON - " + err);
                    }

                    if (this.recentTranslations && this.recentTranslations.length > 0) {
                        this.recentTranslations.map(translation => {
                            const matchTranslation = this.translations.find(t => t.code === translation.code);

                            if (matchTranslation) {
                                translation.link = matchTranslation.link;
                            } else {
                                translation.hideme = true;
                            }
                        });

                        this.showRecent = true;
                    }

                    this.loading = false;
                })
                .catch(err => {
                    console.log(err);
                    this.loading = false;
                });
        },
    };
};

export default call;